//Synthetics  monitoring imports
const SM = () => import('@/views/SM/SM.vue');

// const SMApplications = () =>
//   import('@/components/SM/Applications/Applications.vue');

const SMEndpoints = () => import('@/components/SM/Endpoints/Endpoints.vue');

const SMSecretManager = () =>
  import('@/components/SM/SecretManager/SecretManager.vue');

const SMTokenManager = () =>
  import('@/components/SM/TokenManager/TokenManager.vue');

// const SMApplication = resolve =>
//   require(['@/components/SM/Applications/Application.vue'], resolve);

// const SMDashboard = () =>
//   import('@/components/SM/Applications/Dashboard/Dashboard.vue');

// const SMReports = resolve =>
//   require(['@/components/SM/Applications/Reports/Reports.vue'], resolve);

// const SMKPM = () => import('@/components/SM/Applications/KPM/KPM.vue');

// const SMErrors = () => import('@/components/SM/Applications/Errors/Errors.vue');

// const SMErrorsTable = () =>
//   import('@/components/SM/Applications/Errors/ErrorsTable.vue');
// const SMEventsTable = () =>
//   import('@/components/SM/Applications/Errors/EventsTable.vue');
// const SMSummary = () =>
//   import('@/components/SM/Applications/Errors/Details/ErrorDetails.vue');

const SMAvailability = () =>
  import('@/components/SM/Endpoints/Availability/Availability.vue');

const SMPerformance = () =>
  import('@/components/SM/Endpoints/Performance/Performance.vue');

const AllGroups = () =>
  import('@/components/SM/Endpoints/Availability/AllGroups/AllGroups.vue');
const Group = () =>
  import('@/components/SM/Endpoints/Availability/AllGroups/Group.vue');

const AllEndpoints = () =>
  import('@/components/SM/Endpoints/Availability/Endpoints/Endpoints.vue');
const EndpointGroup = () =>
  import(
    '@/components/SM/Endpoints/Availability/AllGroups/EndpointsTableGroup.vue'
  );

const MappedEndpoints = () =>
  import(
    '@/components/SM/Endpoints/Availability/Endpoints/MappedEndpoints.vue'
  );

export const smRoutes = {
  path: 'sm',
  name: 'sm',
  component: SM,
  redirect: {
    name: 'smEndpoints',
  },
  children: [
    // {
    //   // This opens up the child components
    //   name: 'smApplication',
    //   path: '/smApplication',
    //   component: SMApplications,
    //   redirect: {
    //     name: 'smDashboard',
    //   },
    //   children: [
    //     {
    //       name: 'smDashboard',
    //       path: '/smDashboard',
    //       component: SMDashboard,
    //     },
    //     {
    //       name: 'smKPM',
    //       path: '/smKPM',
    //       component: SMKPM,
    //     },
    //     {
    //       name: 'smErrors',
    //       path: '/smErrors',
    //       component: SMErrors,
    //       redirect: {
    //         name: 'smErrorTable',
    //       },
    //       children: [
    //         {
    //           name: 'smErrorTable',
    //           path: '/',
    //           component: SMErrorsTable,
    //         },
    //         {
    //           name: 'smEventsTable',
    //           path: '/events',
    //           component: SMEventsTable,
    //         },
    //         {
    //           name: 'smEventDetails',
    //           path: '/events/details',
    //           component: SMSummary,
    //         },
    //       ],
    //     },
    //     // {
    //     //   name: 'smReports',
    //     //   path: 'smReports',
    //     //   component: SMReports
    //     // }
    //   ],
    // },
    {
      // This opens up the child components
      name: 'smEndpoints',
      path: 'smEndpoints',
      component: SMEndpoints,
      redirect: {
        name: 'smAvailability',
      },
      children: [
        {
          name: 'smAvailability',
          path: 'smAvailability',
          component: SMAvailability,
          redirect: {
            name: 'allGroups',
          },
          children: [
            {
              name: 'allGroups',
              path: 'all-groups',
              component: Group,
              redirect: {
                name: 'allGroupsPage',
              },
              children: [
                {
                  name: 'allGroupsPage',
                  path: '',
                  component: AllGroups,
                },
                {
                  name: 'groupsEndpoints',
                  path: 'groups-endpoints',
                  component: EndpointGroup,
                },
              ],
            },
            {
              name: 'allEndpoints',
              path: 'all-endpoints',
              component: AllEndpoints,
            },
            {
              name: 'mappedEndpoints',
              path: 'mapped-endpoints',
              component: MappedEndpoints,
            },
          ],
        },
        {
          name: 'smPerformance',
          path: 'smPerformance',
          component: SMPerformance,
        },
      ],
    },
    {
      // This opens up the child components
      name: 'smSecretManager',
      path: 'smSecretManager',
      component: SM,
      redirect: {
        name: 'secretManagerDashboard',
      },
      children: [
        {
          name: 'secretManagerDashboard',
          path: '',
          component: SMSecretManager,
        },
      ],
    },
    {
      // This opens up the child components
      name: 'smTokenManager',
      path: 'smTokenManager',
      component: SM,
      redirect: {
        name: 'tokenManagerDashboard',
      },
      children: [
        {
          name: 'tokenManagerDashboard',
          path: '',
          component: SMTokenManager,
        },
      ],
    },
  ],
};
